function parsePlaneCapacitanceCSV(csvContent) {
  let frequencies = [], curveData = {}
  if (!csvContent) {
    return { frequencies, curveData };
  }
  const lines = csvContent.match(/[^\r\n]+/g);
  if (!lines || !lines.length) {
    return { frequencies, curveData };
  }
  /* frequency,signal1,signal2,...
 */
  let signalObj = {}

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const words = line.split(",");
    //filter inf
    if (i > 0 && words.filter(item => isNaN(item)).length) {
      continue;
    }

    for (let j = 0; j < words.length; j++) {

      if (i === 0) {
        //title
        // frequency,signal1,signal2,...
        if (j > 0) {
          curveData[words[j]] = [];
          signalObj[j] = words[j];
        }
        continue;
      }

      if (j === 0) {
        //frequency
        frequencies.push(Number(words[j]))
      } else {
        //signal capacitance
        curveData[signalObj[j]].push(Number(words[j]))
      }
    }
  }
  return { frequencies, curveData };
}

export {
  parsePlaneCapacitanceCSV
}
